import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.config.productionTip = false

Vue.use(VModal, { dialog: true })

Vue.component('teacher-registration-component', require('./components/Form/TeacherRegistrationComponent.vue').default)
Vue.component('request-change-password-component', require('./components/ChangePassword/RequestChangePasswordComponent.vue').default)
Vue.component('cange-password-form-component', require('./components/ChangePassword/CangePasswordFormComponent.vue').default)

Vue.component('classes-list-component', require('./components/PrivateArea/ClassesListComponent.vue').default)
Vue.component('root-private-area', require('./components/PrivateArea/RootPrivateArea.vue').default)

Vue.component('gallery-component', require('./components/Gallery/GalleryComponent.vue').default)

Vue.component('download-pdf-component', require('./components/Common/DownloadPdfComponent.vue').default)
Vue.component('btn-play-video-component', require('./components/Common/BtnPlayVideoComponent.vue').default)

/** Inizialize VUE */
new Vue({
	el: '#app'
})
